module.exports = __webpack_public_path__ + "assets/img/init_pos_curtain1.ce362f5c.png";